import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import RegisterStep  from './../registerStep/registerStep';
import { appConfig } from "../../../../configApp";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: 'auto',
        padding: '20px ',
        '@media (max-width: 768px)': {
            width: '100%',
            margin: 'auto',
        },
    },
    gridImages: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            maxWidth: '100%',
        }
    },
    gridImagesTable: {
        // width: '80%',
        margin: '20px auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '50%',
            minWidth: 290,
        }
    },
    content: {
        lineHeight: 3,
        '& h3': {
            marginTop: 30,
            fontSize: 20,
            fontWeight: "bold",
            marginBottom: 10,
        },
        '& p': {
            textAlign: 'justify',
            margin: 0,
            padding: 0,
            border: 0,
            font: "inherit",
            verticalAlign: "baseline",
            color: 'rgb(66, 71, 77)',
            '& a': {
                color: 'blue !important',
                padding: '0px 5px'
            }
        },
    },
    gridBtns: {
        '@media (max-width: 768px)': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    }
}));

export default function Index() {

    const classes = useStyles()

    return (
        <div className={classes['root']}>
            <div className={classes['content']} >
                <p>
                    سهام عدالت یکی از سیاست‌های حمایتی و اقتصادی دولت از اقشار مختلف جامعه است. این طرح از دولت نهم آغاز شد و به عنوان نوعی یارانه به وسیله شرکت‌های تعاونی استانی به متقاضیان اختصاص یافت.
                </p>
                <p>
                    طی این سال‌ها، بسیاری از صاحبان سهام عدالت فوت کردند و سهام آنها بلاتکلیف مانده است. با توجه به ارزش روز سهام عدالت بسیاری از وراث افراد متوفی تصمیم دارند این دارایی را انتقال دهند. طبق اعلام رییس سازمان بورس اوراق بهادار فرایند انتقال سهام عدالت متوفیان آغاز و کارگزاری پویان به عنوان متولی انتقال سهام عدالت به وراث انتخاب شده است.
                </p>
                <div className={classes['gridBtns']}>
                    {<a 
                     href={appConfig?.baseUrlDeceased}
                    target='_blank'>
                        <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                            درخواست انتقال سهام عدالت متوفیان
                        </button>
                    </a>}
                </div>
                <p>
                    به منظور آشنایی وراث از مراحل انتقال سهام عدالت متوفیان در این مقاله به تشریح این امر می‌پردازیم. تا انتهای این مقاله با ما همراه باشید.
                </p>
            </div>
            <div className={classes['content']}>
                <h3>
                    استعلام سهام عدالت متوفیان با کدملی
                </h3>
                <p>
                    سامانه استعلام سهام عدالت به نشانی
                    <a href="https://sahamedalat.ir/" target="_blank" >
                        sahamedalat.ir
                    </a>
                    برای اطلاع از تخصیص سهام عدالت و میزان دارایی هر شخص پایه‌ ریزی شده است.
                </p>
            </div>
            <RegisterStep /> 
            <div className={classes['content']}>
                <h3>
                    نحوه ورود به سایت استعلام سهام با کدملی
                </h3>
                <p>
                    جهت دریافت استعلام سهام با کد ملی تنها داشتن کد سجام کافی است. برای دسترسی به اطلاعات، کاربران بازار سرمایه باید وارد سایت سمات به آدرس
                    <a href="https://www.csdiran.ir" target="_blank">
                        www.csdiran.ir
                    </a>
                    شوند. سپس به درگاه یکپارچه ذینفعان وارد شده و ثبت نام کنند.
                </p>
                <p>
                    پس از تکمیل اطلاعات، کاربران با کدملی و رمزعبور می‌توانند وارد پنل کاربری خود شوند. برای امنیت بیشتر رمز یک بار مصرف نیز به شماره همراه سهامدار ارسال می‌شود.
                </p>
                <p>
                    سهامداران پس از ورود به پنل برای اطلاع از تعداد سهام‌ های موجود در سبد سرمایه‌گذاری خود در قسمت درگاه الکترونیک سهامدار، بخش اوراق بهادار، سبددارایی خود را مشاهده می‌کنند.
                </p>
                <p>
                    در بخش سبد دارایی می‌تواند تعداد سهام‌ها و مبلغ سرمایه‌گذاری، گردش معاملات، گزارش سودهای پرداخت شده، مجامع، اطلاعیه‌های نماد، گردش دارایی، تاریخچه سود سهام عدالت و گزارش حق تقدم استفاده نشده قابل مشاهده است.
                </p>
            </div>
            <div className={classes['content']}>
                <h3>
                    استعلام سود سهام عدالت
                </h3>
                <p>
                    بسیاری سوالاتی همچون، سود سهام عدالت چقدر است؟ ارزش سهام عدالت چقدر است؟ چه میزان سود دریافت کردیم؟ دارند. یکی از راه‌های رسیدن به اطلاعات سهام  عدالت مراجعه به سامانه یکپارچه ذینفعان است. برای اطلاع از ارزش سهام عدالت به قسمت درگاه الکترونیک سهامدار، سپس بخش اوراق بهادار مراجعه کنید.
                </p>
                <p>
                    برای دریافت اطلاعات در خصوص سهام عدالت نیز به تاریخچه سود سهام عدالت مراجعه کندی. در این قسمت وضعیت پرداخت، تاریخ، مبلغ و نوع سود آمده است.
                </p>
                <p>
                    با مراجعه به این سایت و ورود کد ملی هر شخص، با دسترسی به شماره همراه وی، می‌توان از اختصاص سهام عدالت وی و میزان آن، آگاهی لازم را کسب نمایید. در صورتی که شخص متوفی مشمول دریافت سهام عدالت باشد، یکی از وراث به نمایندگی از سایرین، می‌تواند برای تقسیم و انتقال سهام عدالت متوفی به کدهای وارثین، اقدامات لازم را انجام دهد.
                </p>
            </div>
            <div className={classes['content']}>
                <h3>
                    انتقال سهام عدالت متوفیان
                </h3>
                <p>
                    در صورتی که متوفی مشمول طرح سهام عدالت بوده و تاریخ فوت ایشان قبل از 1399/05/01 و سهام عدالت ایشان از نوع غیر مستقیم  باشد، پس از فراخوانی که به صورت مرحله بندی که جلوتر به آن اشاره شده است، وراث می‌توانند مراحل انتقال سهام را از طریق کارگزاری طی کنند. درمرحله نخست وراث باید مراحل قانونی انحصار وراثت را به طور کامل طی کرده باشند. ثبت پرونده‌ی انتقال قهری سهام عدالت متوفی به دو روش حضوری (مراجعه به شعب و دفاتر منتخب پیشخوان دولت طرف قرارداد کارگزاری) و غیر حضوری (ثبت در فرم آنلاین) امکان پذیر می‌باشد.
                </p>
            </div>
            <div className={classes['content']}>
                <p>
                    متقاضی انتقال سهام متوفیان سهام عدالت به وراث می‌بایست پس از ورود به درگاه ذی‌نفعان بازار سرمایه به نشانی
                    <a href="https://ddn.csdiran.ir" target="_blank">
                        ddn.csdiran.ir
                    </a>
                    در ابتدا با وارد کردن کد ملی، تاریخ تولد و تاریخ فوت متوفی در بخش «استعلام نوبت پرونده قهری» در درگاه یکپارچه ذی‌نفعان، نسبت به این موضوع که آیا زمان تشکیل پرونده متوفی فرارسیده است یا خیر اطلاع حاصل کنند.
                </p>
                <div className={classes['gridImagesTable']} style={{ marginBottom: 30 }}>
                    <img src="/assets/images/newImages/10.png" alt="" />
                </div>
            </div>
            <div className={classes['content']}>
                <h3>
                    جدول زمان بندی انتقال سهام عدالت متوفیان به وراث
                </h3>
                <div className={classes['gridImagesTable']}>
                    <img src="/assets/images/newImages/table.jpg" alt="" />
                </div>
                <p>
                    وراث متوفیان سال ۱۳۸۴ و قبل از آن در تاریخ ۱۵ آبان، متوفیان سال ۸۵ در تاریخ ۲۷ آبان، سال ۸۶ و ۸۷ در تاریخ ۱۱ آذر، سال ۸۸ و ۸۹ در تاریخ ۲۵ آذر، سال ۹۰ و ۹۱ در تاریخ ۹ دی، سال ۹۲ و ۹۳ در تاریخ ۲۳ دی، سال ۹۴ و ۹۵ در تاریخ ۷ بهمن، سال ۹۶ و ۹۷ در تاریخ ۲۱ بهمن، سال ۹۸ و ۹۹ در تاریخ ۵ اسفند، سال ۱۴۰۰ و به بعد در تاریخ ۱۹ اسفند سال ۱۴۰۲ می بایست با مراجعه به درگاه ذینفعان بازار سرمایه به آدرس
                    <a href="https://ddn.csdiran.ir" target="_blank" >
                        ddn.csdiran.ir
                    </a>
                    نسبت به تعیین وضعیت زمان تشکیل پرونده برای آغاز فرایند انتقال سهام متوفیان سهام عدالت به وراث اقدام کنند.
                </p>
            </div>
            <div className={classes['content']}>
                <h3>
                    روش غیر حضوری
                </h3>
                <p>
                    به سامانه الکترونیکی سهام عدالت کارگزاری پویان مراجعه کرده و مدارک را بارگذاری کنند. بعد از گذراندن مراحل اداری، سهام متوفی به وراث منتقل می‌شود.
                </p>
                <div className={classes['gridBtns']}>
                    {<a 
                   href={appConfig?.baseUrlDeceased}
                    target='_blank'>
                        <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                            درخواست انتقال سهام عدالت متوفیان
                        </button>
                    </a>}
                </div>
                <h5 style={{ fontWeight: 'bold', marginTop: 20 }}>
                    مدارک مورد نیاز برای بارگذاری در سامانه الکترونیکی سهام عدالت کارگزاری پویان :
                </h5>
                <ul>
                    <li>
                        <p>
                            تمامی وراث باید سجامی شده باشند.
                            <a href="https://profilesejam.csdiran.ir/" target="_blank" >
                                (ثبت نام در سامانه سجام و انجام فرآیند احراز هویت)
                            </a>
                        </p>
                    </li>
                    <li>
                        <p>
                            تصویر اصل  گواهی انحصار وراثت یا داد نامه الزامی می باشد
                        </p>
                    </li>
                    <li>
                        <p>
                            تصویر اصل کارت ملی  متوفی الزامی می باشد
                        </p>
                    </li>
                    <li>
                        <p>
                            تصویر اصل شناسنامه و اصل کارت ملی هر یک از وراث الزامی می باشد
                        </p>
                    </li>
                </ul>
                <p>
                    یکی از وراث که سجامی بوده به نمایندگی از سایرین وارد لینک آنلاین به نشانی ذیل می شود :
                    <a 
                     href={appConfig?.baseUrlDeceased}
                    
                    target="_blank" >
                        درخواست انتقال سهام عدالت متوفیان‌
                    </a>
                    و مدارک فوق را بارگزاری و اطلاعات لازم را وارد نموده و پس از ثبت درخواست مدارک زیر را به نشانی کارگزاری پویان ارسال نماید.
                </p>
                <p>
                    نتیجه بررسی مدارک و صحت آن، بعد از طی مراحل قانونی از طریق پیامک به وراث متوفی، اطلاع‌رسانی می‌شود.
                </p>
                <p style={{ color: 'red' }}>
                    ((مدارک بصورت اسکن رنگی و حجم کمتر از 5MB با فرمت‌های png,jpg و pdf بارگذاری شود.))
                </p>
                <h6 style={{ fontWeight: 'bold', marginTop: 20 }}>
                    نشانی جهت ارسال مدارک:
                </h6>
                <p>
                    تهران ، خیابان شهید بهشتی ، تقاطع خیابان خرمشهر و قنبرزاده ، پلاک 222 ، طبقه همکف
                </p>
            </div>
            <div className={classes['content']}>
                <h3>
                    روش حضوری
                </h3>
                <p>
                    یکی از وراث که سجامی بوده به نمایندگی از سایر ورثه با در دست داشتن مدارک زیر، به کارگزاری پویان شعبه مرکزی مراجعه نماید.
                </p>
                <p>
                    اصل و یا کپی برابر اصل گواهی انحصار وراثت یا دادنامه
                    <a href="http://sana.adliran.ir" target="_blank" >
                        http://sana.adliran.ir
                    </a>
                </p>
                <ul>
                    <li>
                        <p>
                            اصل و یا کپی برابر اصل کارت ملی و شناسنامه متوفی
                        </p>
                    </li>
                    <li>
                        <p>
                            تصویر کارت ملی یا شناسنامه هر یک از وراث.
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    );
}

